import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import API from 'api';
import { CurrentUserResponseModel, UTILITY_QUERY } from 'api/utility/utility.model';

export const useCurrentUserQuery = (
  options: UseQueryOptions<
    CurrentUserResponseModel,
    AxiosError,
    CurrentUserResponseModel,
    UTILITY_QUERY[]
  >
) => useQuery([UTILITY_QUERY.ME], () => API.utility.getCurrentUser(), options);
